import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { ProfileComponent } from './profile/profile.component';
import { ManagePasswordComponent } from './manage-password/manage-password.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";
import { ThirdPartyAppComponent } from './third-party/third-party.component';
import { RoleGuard } from '../../guards/role.guard';
import { Role } from '../../models/role.model';

const routes: Routes = [
	{
		path: 'user',
		component: AppContainerComponent,
		children: [
			{
				path: 'profile',
				component: ProfileComponent,
				canActivate: [PrerequisitesGuard]
			},
			{
				path: 'manage-password',
				component: ManagePasswordComponent,
				canActivate: [PrerequisitesGuard]
			},
			{
				path: 'third-party',
				component: ThirdPartyAppComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.StandardFeatureSet, Role.DocReviewFeatureSet, Role.DeleteDocFeatureSet] }
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class UserRoutingModule {
}
